module.exports = __webpack_public_path__ + "img/content-1.bfb93959.png";